import { Env } from '../contracts/env.interface';

const deviceTypes = {
  WEB: 'WEB',
  MOBILE: 'MOBILE'
};

const envCache: { [key: string]: Env } = {};

const initWebEnv = (env: Env) => {
  envCache[deviceTypes.WEB] = env;
};

const initMobileEnv = (env: Env) => {
  envCache[deviceTypes.MOBILE] = env;
};

const getEnv = (): Env => {
  if (typeof document !== 'undefined') {
    return envCache[deviceTypes.WEB];
  } else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return envCache[deviceTypes.MOBILE];
  } else {
    throw new Error('Nodejs environment is not supported');
  }
};

export { initWebEnv, initMobileEnv, getEnv };
